// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/40c2e6e9/" + chunkId + "." + __webpack_require__.h() + ".v40c2e6e9.js";
};